export default function Card({img, name}) {
    return (
        <div className="col-md-4 col-10 mx-auto">
            <div className="card">
                                    <img src={img} className="card-img-top" alt="..." />
                                    <div className="card-body">
                                        <h5 className="card-title">{name}</h5>
                                    </div>
                                </div>
        </div>
    )
}

